export function Quokka({ size = 120 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 160 160"
      role="img"
      aria-label="Flash Quiz quokka"
    >
      <circle cx="80" cy="86" r="52" fill="#FF6B4A" />
      <circle cx="62" cy="80" r="6" fill="#16213A" />
      <circle cx="98" cy="80" r="6" fill="#16213A" />
      <circle cx="64" cy="78" r="2" fill="#FFF7ED" />
      <circle cx="100" cy="78" r="2" fill="#FFF7ED" />
      <path
        d="M66 99c8 7 20 7 28 0"
        fill="none"
        stroke="#16213A"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <circle cx="48" cy="96" r="7" fill="#FFC53D" opacity="0.85" />
      <circle cx="112" cy="96" r="7" fill="#FFC53D" opacity="0.85" />
      <path
        d="M52 42l8 18M108 42l-8 18"
        stroke="#FFC53D"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M38 36l5 14M122 36l-5 14"
        stroke="#FFF7ED"
        strokeWidth="5"
        strokeLinecap="round"
        opacity="0.6"
      />
    </svg>
  );
}
